import { Dialog, DialogActions, DialogContent, LinearProgress } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useAlert } from '../../../context/AlertContext';
import { Link } from '@mui/icons-material';
import documentServices from '../services/documentServices';


function DocumentHyperlinkNote({documentId,callBack}) {
    const {AppAlert } = useAlert()
    const [dialogStatus,setDialogStatus] = useState("");
    const [savingInProgress,setSavingStatus] = useState("");
    const [remark,setRemark] = useState("");
    const [url,setUrl] = useState("");

    const onSubmit = () =>{

        setSavingStatus(true);
        let payload = {
            documentId:documentId,
            url:url,
            remark:remark,
        }
        documentServices.addHyperLink(payload).then( (res)=>{
            AppAlert(res.msg)
            callBack();
        }).catch( (error) => {
            AppAlert(error.msg,"error")
        }).finally(()=>{
            setDialogStatus(false);
            setSavingStatus(false);
        })
        
    }

    return (
        <>
            <div className='btn btn-primary me-2' onClick={()=>setDialogStatus(true)} ><Link /></div>
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="lg"
            >
                <DialogContent>
                    <div className='mt-3'>

                        <div className="form-floating mb-3">
                            <input type="text" className="form-control"  value={url} onChange={(e)=>setUrl(e.target.value)} placeholder="name@example.com" />
                            <label>Link Url</label>
                        </div>
                        <div className="form-floating mb-3 ">
                            <textarea  className="form-control"  placeholder=""  value={remark} onChange={(e)=>setRemark(e.target.value)} style={{height:100}} />
                            <label >Type your remark here ... </label>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <div className='row'>
                        <div className='col-md-12'>
                            {savingInProgress && <LinearProgress />}
                            {!savingInProgress &&
                                <>
                                    <button className='btn btn-outline-primary me-2' onClick={()=>setDialogStatus(false)} >Cancel</button>
                                    <button className='btn btn-primary' disabled={remark===""} onClick={onSubmit}>Save</button>
                                </>
                            }
                        </div>
                    </div>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default DocumentHyperlinkNote